import type { ReactNode } from 'react'
import { Button } from './ui/button'

/** Something the viewer hid (a person, a line, a pin), with a button that shows it again. */
export function HiddenRow({
  avatar,
  onShow,
  showLabel,
  children,
}: {
  avatar: ReactNode
  onShow: () => void
  showLabel: string
  children: ReactNode
}) {
  return (
    <div className="flex items-center gap-3 rounded-md border border-border bg-card px-3 py-2">
      {avatar}
      <span className="flex-1 truncate text-sm">{children}</span>
      <Button type="button" variant="ghost" size="sm" className="text-muted-foreground" onClick={onShow}>
        {showLabel}
      </Button>
    </div>
  )
}
